import styled from 'styled-components';

export const DrawerBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-color: var(--color-black2);
`;
